import { render, staticRenderFns } from "./AssinaturaLayout.vue?vue&type=template&id=82d8f022"
import script from "./AssinaturaLayout.vue?vue&type=script&lang=js"
export * from "./AssinaturaLayout.vue?vue&type=script&lang=js"
import style0 from "./AssinaturaLayout.vue?vue&type=style&index=0&id=82d8f022&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports